import { io } from 'socket.io-client';
import API from './api';

// api.js의 baseURL('http://host:포트/api')에서 '/api'를 뗀 주소가 socket.io 서버 주소(같은
// Express 서버가 REST와 웹소켓을 함께 처리함 — backend/server.js 참고).
const SOCKET_URL = (API.defaults.baseURL || '').replace(/\/api\/?$/, '');

let socket = null;
let socketToken = null; // 지금 연결에 쓰인 토큰 — 로그아웃/재로그인으로 토큰이 바뀌면 새로 연결한다

// 로그인된 상태에서 창(브라우저 탭/팝업창)마다 하나씩 소켓 연결을 갖는다. 메인 창과 채팅
// 팝업창은 서로 다른 브라우저 창(별도 JS 실행환경)이라 이 모듈도 창마다 새로 로드되므로,
// 자연스럽게 창별로 하나씩 연결되고, 서버는 같은 사용자의 여러 연결을 "user:<아이디>" room으로
// 묶어 모든 창에 동일한 이벤트를 뿌려준다.
export function getSocket() {
  const token = sessionStorage.getItem('token');
  if (!token) { disconnectSocket(); return null; }
  if (socket && socketToken === token) return socket;
  if (socket) socket.disconnect();
  socket = io(SOCKET_URL, { path: '/socket.io', auth: { token }, transports: ['websocket', 'polling'] });
  socketToken = token;
  return socket;
}

export function disconnectSocket() {
  if (socket) { socket.disconnect(); socket = null; socketToken = null; }
}